export const NavPaths = [
    {
        id: 0,
        pathName: 'Profile',
        pathUrl: 'profile',
    },
    {
        id: 1,
        pathName: 'My Applications',
        pathUrl: 'jobs',
    },
    {
        id: 2,
        pathName: 'Document Upload',
        pathUrl: 'documents',
    },
    {
        id: 3,
        pathName: 'Your Acknowledgement',
        pathUrl: 'status',
    },
];
